import SellRefrigerantService from "../../../services/SellRefrigerant/SellRefrigerantService";
import createListStateModule from "../createListStateModule";
import gasTypesStatePlugin from "../plugins/gasTypesStatePlugin";
import unpublishOfferPlugin from "../sell-refrigerant/sellRefrigerantListingPlugins";
import StockService from "../../../services/Stock/StockService";

const cleanRefrigerantListingStateModule = createListStateModule({
    stateNamespace: "sellrefrigerant",
    itemsPropertyName: "sellingItems",
    loadItemsMethodName: "loadSellingItems",
    itemsDataMethod: StockService.getCleaningListingData,
    loadDetailMethodName: "loadSellingItemById",
    detailDataMethod: SellRefrigerantService.getSellingItemById,
    detailsPropertyName: "sellingItemData",
    updateMethodName: "updateSellingItem",
    updateDataMethod: () => {},
    createMethodName: 'createSellingItem',
    createDataMethod: () => {},
    defaultItemsData: {data:[]},
    plugins: [unpublishOfferPlugin, gasTypesStatePlugin]
});

export default cleanRefrigerantListingStateModule;
